module.exports = __webpack_public_path__ + "static/header@2x-d95a3b3ceafb8d6f6056ae8c2b25c4fe.png";